export enum WheelOfFortuneStates {
  inProgress,
  win,
  summary,
  loose,
  cancelled,
  error,
}
